import { Button } from "../../../ui-components";
import { useNavigate } from "react-router-dom";
import { route } from "../../../routes";
import { CorporateBondId } from "@goodfill/domain-properties";

export const BondDetailInvestButton = ({ bondId }: { bondId: CorporateBondId }) => {
  const navigate = useNavigate();

  return (
    <div className="w-80">
      <Button fill font={"medium"} size={"medium"} primary onClick={() => navigate(route.orderBuy(bondId))}>
        Invest
      </Button>
    </div>
  );
};
